import { FAILED_STATUS } from "@/context/BackgroundContext";
import { FILE_TYPE_NO_CONVERSION } from "@/util/constants";
import { BaseTask } from "@/util/interfaces/background/BaseTask";

export const IN_PROGRESS_STATUS = "IN_PROGRESS";
export const FAILED_PROGRESS_STATUS = "FAILED";
export const FAILED_DURING_CONVERSION = "FAILED DURING CONVERSION";
export const COMPLETED_PROGRESS_STATUS = "COMPLETED";
const FAILED_CONVERSION_MESSAGE = "Failed PDF conversion for Preview";
const validateUploadedFileManualResponse = (task: BaseTask, uploaded_files: string[]) => {
  const { pollingResponse, file } = task;
  const { name } = file;
  if (uploaded_files.includes(name)) {
    const spplitedName = name.split(".");
    if (FILE_TYPE_NO_CONVERSION.includes(spplitedName.at(-1) ?? "")) {
      return {
        text: "File successfully uploaded",
        status: COMPLETED_PROGRESS_STATUS,
      };
    }
    if (pollingResponse) {
      // Handle the case when pollingResponse exists (add your logic here)
      const pollingResultFiles = pollingResponse.data?.result[0];
      const { files } = pollingResultFiles;
      const found = files.find((f: any) => f.name === name);
      if (found?.status === "COMPLETED") {
        return {
          text: "File successfully uploaded",
          status: COMPLETED_PROGRESS_STATUS,
        };
      }
      if (found?.status === "FAILED") {
        return {
          status: FAILED_DURING_CONVERSION,
          text: FAILED_CONVERSION_MESSAGE,
        };
      }
    }
    if (task.status === FAILED_STATUS) {
      return {
        status: FAILED_DURING_CONVERSION,
        text: FAILED_CONVERSION_MESSAGE,
      };
    }
    return {
      status: IN_PROGRESS_STATUS,
      text: "Conversion process in progress",
    };
  }
};
export const getManualTaskConfig = (task: BaseTask) => {
  const { response, file } = task;
  const { name } = file;
  const respondedFiles = response.data?.result[0];
  if (respondedFiles) {
    const { skipped_files, uploaded_files } = respondedFiles;
    // Look for the file on the skipped list
    if (skipped_files.includes(name)) {
      return {
        text: "Failed during uploading",
        status: FAILED_PROGRESS_STATUS,
      };
    }
    return validateUploadedFileManualResponse(task, uploaded_files);
  }
  return {
    text: "Process failed",
    status: FAILED_PROGRESS_STATUS,
  };
};
const getTeamsTaskConfigStatus = (foundTask: any) => {
  if (foundTask.status === "COMPLETED") {
    return {
      text: "File successfully uploaded",
      status: COMPLETED_PROGRESS_STATUS,
    };
  }
  if (foundTask.status === "IN_PROGRESS") {
    return {
      text: `${foundTask.task.toLowerCase()} in progress`,
      status: IN_PROGRESS_STATUS,
    };
  }
  if (foundTask.status === "FAILED") {
    return {
      text:
        foundTask.task === "CONVERT"
          ? FAILED_CONVERSION_MESSAGE
          : `Failed during ${foundTask.task.toLowerCase()} process`,
      status: foundTask.task === "CONVERT" ? FAILED_DURING_CONVERSION : FAILED_PROGRESS_STATUS,
    };
  }
};
export const getTeamsTaskConfig = (task: BaseTask) => {
  const { pollingResponse, status, file } = task;
  const { name } = file;
  if (pollingResponse) {
    const resultArr = pollingResponse.data?.result;
    const resultObj = Array.isArray(resultArr) && resultArr.length > 0 ? resultArr[0] : undefined;
    if (resultObj?.files) {
      const { files } = resultObj;
      const found = files.find((file: any) => file.name === name);
      if (found) {
        return getTeamsTaskConfigStatus(found);
      }
    }
  }
  if (status === FAILED_STATUS) {
    return {
      text: "Process failed",
      status: FAILED_PROGRESS_STATUS,
    };
  }
  return {
    text: "Upload in progress",
    status: IN_PROGRESS_STATUS,
  };
};
